export default __webpack_public_path__ + "static/media/logo-vertical-sin-fondo.fb9dba96.png";